import ApiRequest from "../util/ApiRequest";

export default class LiveStreaming {
    getUrlVideo = async (streamingCode) => {
        return await ApiRequest.set(`/v1/liveStreaming/${streamingCode}/active`, "GET");
    }
}